export class PageTitleInfo {
    pageTitle: string;
    pageSubTitle: string;
    pageTitleImagePath: string;
}